<template>
  <div class="container">
    <div class="row first">
      <div class="col-xs-12 bg-color-w-090 padding-b-5">
        <div class="display-b border-1 border-solid border-color-b-010 margin-0-auto border-radius-4 width-080 margin-t-10 margin-b-10 text-align-c">
          <span class="cursor-p width-050 float-l margin-0 padding-5 padding-l-14 padding-r-14 display-ib font-size-s" v-bind:class="[{'bg-color-b-080': showingLifts}, showingLifts ? 'color-w-0100' : 'color-b-080']" @click="showLifts">Lifts</span>
          <span class="cursor-p width-050 margin-0 padding-5 padding-l-14 padding-r-14 display-ib font-size-s" v-bind:class="[{'bg-color-b-080': showingTrails}, showingTrails ? 'color-w-0100' : 'color-b-080']" @click="showTrails">Trails</span>
        </div>
      </div>
      <div class="col-xs-12 border-b-1 border-solid border-color-b-010 padding-b-5 legend">
        <div class="display-t font-size-xxs text-trans-u color-b-060" v-show="showingTrails">
          <div class="display-tc width-0100">Trail</div>
          <div class="display-tc"><span class="display-ib width-50 text-align-c">Open</span></div>
          <div class="display-tc"><span class="display-ib width-80 text-align-c">Groomed</span></div>
        </div>
        <div class="display-t font-size-xxs text-trans-u color-b-060" v-show="showingLifts">
          <div class="display-tc width-0100">Lift</div>
          <div class="display-tc"><span class="display-ib width-60 text-align-c">Status</span></div>
        </div>
      </div>
    </div>
    <div class="row second">
      <w-loader v-show="isLoading"></w-loader>
      <div class="col-xs-12 overflow-a list" v-show="!isLoading">
        <w-list-item v-for="(trailStatus, index) in trailsStatus" :key="trailStatus.id + '_' + index" :listItem="trailStatus" v-show="showingTrails"></w-list-item>
        <w-list-item v-for="(liftStatus, index) in liftsStatus" :key="liftStatus.id + '_' + index" :listItem="liftStatus" v-show="showingLifts"></w-list-item>
      </div>
    </div>
  </div>
</template>

<script>
  // Import components
  import WListItem from '@/components/ListItem.vue'
  import WLoader from '@/components/shared/Loader.vue'

  // Import services
  import widgetService from '@/services/widget-service'

  // Import libraries
  import _ from 'lodash'
  
  export default {
    data () {
      return {
        showingTrails: false,
        showingLifts: true,
        trailsStatus: [],
        liftsStatus: [],
        isLoading: true
      }
    },
    components: {
      WListItem,
      WLoader
    },
    mounted () {
      this.refresh()
    },
    methods: {
      showTrails () {
        this.showingTrails = true
        this.showingLifts = false
      },
      showLifts () {
        this.showingTrails = false
        this.showingLifts = true
      },
      refresh () {
        const self = this
        self.isLoading = true
        widgetService.getStatus(this.$route.query.json)
          .then(function (statusData) {
            self.trailsStatus = _.filter(statusData, { type: 'trail' })
            self.liftsStatus = _.filter(statusData, { type: 'lift' })

            self.isLoading = false
          })
      }
    }
  }
</script>

<style lang="scss">
  .list {
    -webkit-overflow-scrolling: touch;
  }

  .first {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 110vw;
    z-index: 9999;
    background-color: white;
  }

  .second {
    padding-top: 75px;
  }

  .legend {
    padding-left: 8%;
    padding-right: 8%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Status.vue